import { render, staticRenderFns } from "./coursParent.vue?vue&type=template&id=194b9cdc&"
import script from "./coursParent.vue?vue&type=script&lang=js&"
export * from "./coursParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports